export const navigation = [
    { name: 'How It Works', target: 'solution', link: "https://jigsaw.finance/#solution" },
    { name: 'Documentation', target: 'documentation', link: "https://jigsaw.gitbook.io/jigsaw-protocol" },
    { name: 'Contact', target: 'contact', link: "mailto:admin@jigsaw.finance" },
];
